import { render, staticRenderFns } from "./Riasec.vue?vue&type=template&id=f206d106&scoped=true"
import script from "./Riasec.vue?vue&type=script&lang=js"
export * from "./Riasec.vue?vue&type=script&lang=js"
import style0 from "./Riasec.vue?vue&type=style&index=0&id=f206d106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f206d106",
  null
  
)

export default component.exports